const reportThirdPartyContent = async (
  url,
  uuid,
  location,
  type = 'unknown',
  { appSlug, deviceHeader } = {}
) => {
  const data = {
    url,
    type,
    latitude: location?.latitude,
    longitude: location?.longitude,
    install_id: uuid
  }

  return fetch(`https://kds.svc.scantrust.com/data/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': import.meta.env.VITE_WHITELIST_BLACKLIST_API_KEY,
      'X-SCANTRUST-APP': appSlug,
      'x-scantrust-device': deviceHeader
    },
    body: JSON.stringify(data)
  })
    .then(async (resp) => {
      if (resp.status === 200) {
        return resp.json()
      } else if (resp.status === 404) {
        return Promise.reject(new Error('code_not_found', { cause: resp }))
      } else {
        const msg = await resp.json()
        return Promise.reject(new Error('server', { cause: msg }))
      }
    })
    .then((dataJson) => {
      return dataJson
    })
}

export default reportThirdPartyContent
